import { ComputedPromotionStatus } from '../stores/types/promotions.interface';

export const getPromotionStatusLabel = (status: ComputedPromotionStatus): string => {
  switch (status) {
    case ComputedPromotionStatus.DELETED:
      return 'archived';
    default:
      return status.toLowerCase();
  }
};
